import { Component } from '@angular/core';

@Component({
  selector: 'era-master',
  templateUrl: './master.component.html',
})
export class MasterComponent {}
